import FlexContainer from 'components/common/FlexContainer';
import NoSavedCredit from 'components/saved-credits/NoSavedCredit/';
import SavedCreditsBanner from 'components/saved-credits/SavedCreditsBanner';
import SavedCreditsList from 'components/saved-credits/SavedCreditsList';
import SkipNavLocation from 'components/common/SkipNavLocation';
import { Spin } from 'antd';
import useCreditBookmarks from 'hooks/use-credit-bookmarks';
import useTranslation from 'hooks/use-translation';

export default function SavedCreditItems(): JSX.Element {
  const translation = useTranslation();
  const { creditBookmarks } = useCreditBookmarks();

  if (!translation) {
    return <Spin />;
  }

  return (
    <FlexContainer className='saved-credits'>
      <SkipNavLocation>
        <SavedCreditsBanner />
      </SkipNavLocation>
      {creditBookmarks.size ? <SavedCreditsList /> : <NoSavedCredit />}
    </FlexContainer>
  );
}
